import { useCallback, useEffect, useState } from "react";
import { apiFetchPublic, ApiError } from "../lib/api";

/** @typedef {import("../data/aboutSelfies").AboutSelfie} AboutSelfie */

/**
 * @returns {{
 *   selfies: AboutSelfie[],
 *   loading: boolean,
 *   error: string,
 *   reload: () => Promise<void>,
 * }}
 */
export function useAboutSelfies() {
  const [selfies, setSelfies] = useState(/** @type {AboutSelfie[]} */ ([]));
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const reload = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const body = await apiFetchPublic("/about-selfies");
      setSelfies(body.data.selfies || []);
    } catch (err) {
      setSelfies([]);
      setError(err instanceof ApiError ? err.message : "Couldn't load selfies.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { selfies, loading, error, reload };
}
